import React, { useEffect } from 'react'
import OnlyAuthorizedMessage from '../../components/OnlyAuthorizedMessage'
import DynamicForm, { IDynamicForm, IDynamicFormElement } from '../../components/Form/DynamicForm'
import ItemsApp from '../../features/items/ItemsApp'
import GenerateForm from '../../components/Form/GenerateForm'
import { useDispatch } from 'react-redux'
import { addNewForm, createOrUpdateElementData } from '../../components/Form/formsSlice'

export default function VerifyItem() {

    const dispatch = useDispatch()

    const itemsApp = new ItemsApp()

    const elemPrefix: string = "verify_item_form_"

    const elements: IDynamicFormElement[] = [
        {
            id: elemPrefix + "unique_id",
            xs: 12,
            type: "TextField",
            label: "Enter/Scan Item Unique ID",
            fullWidth: true,
            enableQrCodeScanner: true,
            validateInput: (text: string) => itemsApp.validateUniqueId(text),
            placeholder: "01D23DAE-0384-43DB-A",
            // handleKeyUp: (e) => e.key === "Enter" && handleSubmit()
        },
    ]

    const form: IDynamicForm = {
        name: "verify-item-form",
        elements: elements
    }

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(elemPrefix + name, elementsData).value

    const itemUniqueId = singleElemDataValue("unique_id")

    /**
     * Create form elem data
     */
    const createFormElemData = () => {
        form.elements.map((elem) => dispatch(createOrUpdateElementData({
            name: elem.id,
            value: ""
        })))
    }

    /**
     * Create form
     */
    useEffect(() => {
        dispatch(addNewForm(form))
        createFormElemData()
    }, [])

    /**
     * Reset error message
     */
    const resetErrorMessage = () => DynamicForm.createOrUpdateFormMessage(form.name, { shown: false, type: "error", message: "" }, dispatch)

    /**
     * Update form loading
     */
    const updateFormLoadingStatus = (loading: boolean) => DynamicForm.updateFormLoadingStatus(form.name, loading, dispatch)

    /**
     * Handle submit
     */
    const handleSubmit = () => {

        resetErrorMessage()

        if (itemsApp.validateUniqueId(itemUniqueId)){

            resetErrorMessage()
            updateFormLoadingStatus(true)

            itemsApp.verifyItem(itemUniqueId)
                .then(response => {
                    updateFormLoadingStatus(false)
                    window.location.replace(`/items/${response.data.unique_id}`)
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : "Fatal Error"
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "error", message: message }, dispatch)

                    updateFormLoadingStatus(false)
                })

        }else{
            DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "error", message: "Invalid Unique ID" }, dispatch)
        }

    }

    /**
     * Check text field value
     */
    useEffect(() => {
        if (itemUniqueId){
            handleSubmit()
        }
    }, [itemUniqueId])

    return <div className="content-section-wrapper page-container-wrapper"><OnlyAuthorizedMessage /></div>

    return(
        <div className="verify-item-container">
            <div className="content-of-verify-item-container content-section-wrapper page-container-wrapper">

                <div className="page-container-head-box">
                    <div className="content-of-page-container-head-box">
                        <h1>Verify Item</h1>
                    </div>
                </div>

                <div className="only-auth-message-wrapper"><OnlyAuthorizedMessage /></div>

                <div className="form-box-of-verify-item-container">
                    <div className="content-of-form-box-of-verify-item-container">
                        <GenerateForm name={form.name} />
                    </div>
                </div>

            </div>
        </div>
    )
}